import { Box, Skeleton } from '@mui/material';

import { TableSkeleton } from './ModuleSkeleton';

const ListSkeleton = ({ length, width, height, variant = 'text' }) =>
  Array.from({ length }, (_, i) => (
    <Skeleton variant={variant} key={i} width={width} height={height} />
  ));

const SubHeaderSkeleton = () => (
  <Box>
    <Skeleton variant="text" width={150} height={50} />
    <Skeleton variant="rounded" width={350} height={150} />
  </Box>
);

const HeaderSkeleton = () => (
  <Box>
    <Skeleton variant="text" width={150} height={50} />
    <Skeleton variant="text" width={200} height={50} />
  </Box>
);

const AvailabilitySkeleton = () => (
  <Box>
    <Skeleton width={150} height={50} />
    <ListSkeleton length={7} height={30} width={300} />
    <Skeleton width={190} height={50} />
  </Box>
);

const SetupSkeleton = () => (
  <Box mt="2rem">
    <ListSkeleton length={7} height={40} width={400} />
  </Box>
);

export const ButtonsSkeleton = () => (
  <Box
    sx={{
      display: 'flex',
      gap: '1rem',
      alignItems: 'flex-start',
    }}
  >
    <Skeleton width="5rem" height="3rem" variant="rounded" />
    <Skeleton width="15rem" height="3rem" variant="rounded" />
    <Skeleton width="10rem" height="3rem" variant="rounded" />
  </Box>
);

const AmenityInfoSkeleton = () => (
  <>
    <SubHeaderSkeleton />
    <HeaderSkeleton />
    <AvailabilitySkeleton />
    <SetupSkeleton />
    <ButtonsSkeleton />
    <TableSkeleton />
  </>
);

export default AmenityInfoSkeleton;
